import { el } from '../../core/dom.js';
import { openModal } from '../../components/modal.js';
import { toast } from '../../components/toast.js';
import { LANGUAGES, languageOptionLabel } from '../../core/languages.js';
import { createTenant } from './actions.js';
import { validateCreate } from './model.js';

function field(label, attrs) {
  return el('label', { class: 'org-field' },
    el('span', {}, label),
    el('input', { class: 'org-input', ...attrs }));
}

/**
 * @param {{ onCreated: () => void|Promise<void> }} opts
 */
export function openCreateOrg(opts) {
  const holder = { close() {} };
  const form = {
    orgName: '',
    adminName: '',
    adminEmail: '',
    password: '',
    chatLanguage: 'en',
  };
  const err = el('p', { class: 'org-form-err', hidden: true });
  let busy = false;

  async function submit() {
    if (busy) return;
    err.hidden = true;
    const checked = validateCreate(form);
    if (checked.error) {
      err.textContent = checked.error;
      err.hidden = false;
      return;
    }
    busy = true;
    const result = await createTenant(checked.body);
    busy = false;
    if (!result || result.error) {
      err.textContent = (result && result.error) || 'Could not create organization';
      err.hidden = false;
      return;
    }
    toast(`"${checked.body.orgName}" created successfully`);
    holder.close();
    if (opts.onCreated) await opts.onCreated();
  }

  const body = el('div', { class: 'org-form' },
    err,
    el('p', { class: 'org-hint' },
      'Creates an active organization immediately (no approval step). The admin you set here can sign in right away.'),
    field('Organization name', {
      type: 'text',
      placeholder: 'Enter organization name',
      autocomplete: 'organization',
      onInput: (event) => { form.orgName = event.target.value; },
    }),
    field('Admin name', {
      type: 'text',
      placeholder: 'Enter admin name',
      autocomplete: 'name',
      onInput: (event) => { form.adminName = event.target.value; },
    }),
    field('Admin email', {
      type: 'email',
      placeholder: 'name@company.com',
      autocomplete: 'email',
      onInput: (event) => { form.adminEmail = event.target.value; },
    }),
    field('Admin password', {
      type: 'password',
      placeholder: 'Minimum 6 characters',
      autocomplete: 'new-password',
      onInput: (event) => { form.password = event.target.value; },
    }),
    el('label', { class: 'org-field' },
      el('span', {}, 'Preferred chat language'),
      el('select', {
        class: 'org-input',
        onChange: (event) => { form.chatLanguage = event.target.value; },
      },
      ...LANGUAGES.map((lang) => el('option', {
        value: lang.code,
        selected: lang.code === 'en' ? true : null,
      }, languageOptionLabel(lang))))),
    el('div', { class: 'org-form-actions' },
      el('button', {
        type: 'button',
        class: 'org-btn',
        onClick: () => holder.close(),
      }, 'Cancel'),
      el('button', {
        type: 'button',
        class: 'org-cta',
        onClick: () => submit(),
      }, 'Create Organization')));

  const modal = openModal({
    title: 'Add Organization',
    className: 'org-modal',
    body,
  });
  holder.close = modal.close;
  return modal;
}
